import { $ } from 'bits/jquery'
import sortBy from 'lodash.sortby'

export default {
  getSortIndex(ts) {
    if (ts == null) {
      ts = new Date()
    }
    return new Date(ts.toISOString()).getTime() / 1000
  },
  getTopSortIndex() {
    return -this.getSortIndex()
  },
  getBottomSortIndex() {
    return this.getSortIndex()
  },
  sortSections(sectionsAsArray) {
    return sortBy(sectionsAsArray, section => {
      return section['sort_index']
    })
  },
  getNewIndex(item, options) {
    if (options == null) {
      options = {}
    }
    let $item = $(item)
    let $prev = $item.prev('.surface-section')
    let $next = $item.next('.surface-section')
    if ($next.length === 0 && $prev.length === 0) {
      // Do nothing
      return null
    } else {
      // sorted in descending order, largest rank at the top
      let nextIndex, prevIndex
      if ($next.length === 0) {
        // moved to bot
        nextIndex = this.getBottomSortIndex()
      } else if ($prev.length === 0) {
        // moved to top
        prevIndex = this.getTopSortIndex()
      }
      if (nextIndex == null) {
        nextIndex = parseInt($next.attr('data-rank'))
      }
      if (prevIndex == null) {
        prevIndex = parseInt($prev.attr('data-rank'))
      }
      let sortIndex = parseInt((prevIndex + nextIndex) / 2)
      let sectionId = $item.data('section-id')

      return {
        sectionId: sectionId,
        sortIndex: sortIndex,
      }
    }
  },
}
